<template lang="html">
  <div class="cw-basic-cell level is-mobile" @click="$emit('click')">
    <div class="level-left">
      <slot name="left-area"></slot>
    </div>
    <div class="level-item is-shrinkable is-block is-pad-left-1">
      <slot name="left-fill-area"></slot>
    </div>
    <div class="level-item is-not-growable is-marginless">
      <slot name="right-area-2"></slot>
    </div>
    <div class="level-item is-not-growable is-marginless">
      <slot name="right-area-1"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cw-basic-cell',
  props: {},
};
</script>

<style lang="stylus" scoped>

$itemPadding = 0.5rem

.cw-basic-cell {
  user-select: none
}

.cw-basic-cell.level {
  margin-bottom: 0
  padding-top: $itemPadding
  padding-bottom: $itemPadding
  min-height: 50pt
  cursor: pointer
}

.cw-list-cell:active {
  background-color: #eee
}
</style>
